import React from 'react';
import styled from 'styled-components';
import TopAppBar from '@pedidosya/web-fenix/system/TopAppBar';

const SpaceContainer = styled.div`
  height: 20px;
  width: 100%;
`;

const MobileHeader = ({
  title = '',
  showBack = true,
  withMarginBottom = false,
  onBack = () => {},
}) => (
  <>
    <TopAppBar
      left={showBack ? 'icon' : 'empty'}
      middle={title ? 'title' : 'empty'}
      onGoBack={onBack}
      titleValue={title}
    />
    {!!title && withMarginBottom && (
      <SpaceContainer data-testid="space-container-div" />
    )}
  </>
);

export default MobileHeader;
